import { useState } from "react";
import { Link } from "react-router-dom";
import { data } from "../data";

export default function MuralMosaic() {
  const [active, setActive] = useState(null);

  // Mosaic layout config (8 tiles)
  const layout = [
    { i: 0, cls: "col-span-12 md:col-span-7 row-span-2 aspect-[16/10]" },
    { i: 1, cls: "col-span-6 md:col-span-5 aspect-[4/5]" },
    { i: 2, cls: "col-span-6 md:col-span-5 aspect-[4/5]" },
    { i: 3, cls: "col-span-6 md:col-span-4 aspect-[4/3]" },
    { i: 4, cls: "col-span-6 md:col-span-4 aspect-[4/3]" },
    { i: 5, cls: "col-span-12 md:col-span-4 aspect-[16/9]" },
  ];

  const items = data.slice(0, 6);

  return (
    <section className="relative py-24 md:py-40 px-5 md:px-10 bg-[var(--bg-soft)] overflow-hidden">
      {/* Background detail */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute top-1/3 -right-32 w-[400px] h-[400px] rounded-full blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(194,92,58,0.4), transparent 70%)" }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
              — The Wall Index
            </div>
            <h2 className="mt-3 font-display font-light text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight text-[var(--bone)]">
              Every wall, a <span className="italic font-extralight">story.</span>
            </h2>
          </div>
          <Link
            to="/gallery"
            className="group inline-flex items-center gap-3 px-5 py-2.5 border border-[var(--line-strong)] text-[var(--bone)] rounded-full text-sm tracking-wide hover:border-[var(--clay)] hover:text-[var(--clay)] transition-colors"
          >
            Open the gallery
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        <div className="grid grid-cols-12 gap-3 md:gap-4 auto-rows-min">
          {items.map((p, i) => (
            <Link
              key={p.id}
              to={`/ourwork/muralarts/${p.id}`}
              className={`group relative block overflow-hidden bg-[var(--bg-elevated)] ${layout[i]?.cls || "col-span-6 md:col-span-4 aspect-[4/3]"}`}
              onMouseEnter={() => setActive(p.id)}
              onMouseLeave={() => setActive(null)}
            >
              <img
                src={p.img1}
                alt={p.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
              />
              {/* Dark overlay (more on hover) */}
              <div className={`absolute inset-0 bg-[var(--ink)] transition-opacity duration-500 ${active === p.id ? "opacity-20" : "opacity-40"}`} />

              {/* Number badge */}
              <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.32em] text-[var(--bone)]/80 flex items-center gap-2">
                <span className="font-display text-3xl text-[var(--clay)] tabular-nums leading-none">
                  0{i + 1}
                </span>
                <span className="block w-6 h-px bg-[var(--bone)]/60" />
              </div>

              {/* Bottom caption */}
              <div className="absolute left-0 right-0 bottom-0 p-4 md:p-6 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.28em] text-[var(--bone)]/70">
                    Mural
                  </div>
                  <h3 className="font-display text-lg md:text-2xl text-[var(--bone)] leading-tight">
                    {p.title}
                  </h3>
                </div>
                <span className={`w-10 h-10 grid place-items-center rounded-full border border-[var(--bone)] text-[var(--bone)] transition-all duration-500 ${active === p.id ? "bg-[var(--clay)] border-[var(--clay)] rotate-0" : "-rotate-45"}`}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M13 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}